<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="incomeList" class="container pb-5">
  <h1 class="lifedi-color text-center">
    รายการทางการเงิน
  </h1>

  <h5 class="text-left my-5">หมวดหมู่:
    <span *ngIf="category === 'workshop'">ตารางกิจกรรม</span>
    <span *ngIf="category === 'course'">คอร์สเรียน</span>
    <span *ngIf="category === 'measure'">แบบทดสอบ</span>
  </h5>

  <div *ngIf="category === 'workshop'">
    <h4 class="text-left lifedi-color my-3" style="text-decoration: underline;">Workshop</h4>
    <div class="row d-flex justify-content-center mb-5">
      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">จำนวนผู้สมัคร</h4>
          <div *ngIf="incomeList.workshop_data.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีผู้สมัคร</h4>
          </div>
          <div *ngIf="incomeList.workshop_data.length !== 0" class="scroll">
            <table class="table table-borderless">
              <tbody>
                <tr *ngFor="let item of incomeList.workshop_data">
                  <th scope="row">{{ item.WORKSHOP_NAME }}</th>
                  <td class="text-right">{{ item.COUNT_REGISTED | number }} คน</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>
      </div>

      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">รายได้</h4>
          <div *ngIf="incomeList.workshop_data.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีรายได้</h4>
          </div>
          <div *ngIf="incomeList.workshop_data.length !== 0" class="scroll">
            <table class="table table-borderless">
              <tbody>
                <tr *ngFor="let item of incomeList.workshop_data">
                  <th scope="row">{{ item.WORKSHOP_NAME }}</th>
                  <td class="text-right">{{ item.SUM_PRICE | number }} บาท</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>
      </div>
    </div>
    <h4 class="text-left lifedi-color my-3" style="text-decoration: underline;">Consult</h4>
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">จำนวนผู้สมัคร</h4>
          <div *ngIf="incomeList.consult_data.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีผู้สมัคร</h4>
          </div>
          <div *ngIf="incomeList.consult_data.length !== 0" class="scroll">
            <table class="table table-borderless">
              <tbody>
                <tr *ngFor="let item of incomeList.consult_data">
                  <th scope="row">{{ item.CONSULT_NAME }}</th>
                  <td class="text-right">{{ item.COUNT_REGISTED | number }} คน</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>
      </div>

      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">รายได้</h4>
          <div *ngIf="incomeList.consult_data.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีรายได้</h4>
          </div>
          <div *ngIf="incomeList.consult_data.length !== 0" class="scroll">
            <table class="table table-borderless">
              <tbody>
                <tr *ngFor="let item of incomeList.consult_data">
                  <th scope="row">{{ item.CONSULT_NAME }}</th>
                  <td class="text-right">{{ item.SUM_PRICE | number }} บาท</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div *ngIf="category === 'course'">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">จำนวนผู้สมัคร</h4>
          <div *ngIf="incomeList.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีผู้สมัคร</h4>
          </div>
          <table *ngIf="incomeList.length !== 0" class="table table-borderless">
            <tbody>
              <tr *ngFor="let item of incomeList">
                <th scope="row">{{ item.COURSE_NAME }}</th>
                <td class="text-right">{{ item.COUNT_REGISTED | number }} คน</td>
              </tr>
            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">รายได้</h4>
          <div *ngIf="incomeList.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีรายได้</h4>
          </div>
          <table *ngIf="incomeList.length !== 0" class="table table-borderless">
            <tbody>
              <tr *ngFor="let item of incomeList">
                <th scope="row">{{ item.COURSE_NAME }}</th>
                <td class="text-right">{{ item.SUM_PRICE | number }} บาท</td>
              </tr>
            </tbody>
          </table>
        </mat-card>
      </div>
    </div>
  </div>

  <div *ngIf="category === 'measure'">
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">จำนวนผู้ทำแบบทดสอบ</h4>
          <div *ngIf="incomeList.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีผู้ทำแบบทดสอบ</h4>
          </div>
          <table *ngIf="incomeList.length !== 0" class="table table-borderless">
            <tbody>
              <tr *ngFor="let item of incomeList">
                <th scope="row">{{ item.MEASURE_NAME }}</th>
                <td class="text-right">{{ item.COUNT_REGISTED | number }} คน</td>
              </tr>
            </tbody>
          </table>
        </mat-card>
      </div>

      <div class="col-12 col-lg-6 col-md-12 col-sm-12">
        <mat-card class="my-3">
          <h4 class="text-center text-primary mb-3">รายได้จากรายงานผล</h4>
          <div *ngIf="incomeList.length === 0">
            <h4 class="text-center text-secondary">ยังไม่มีรายได้จากรายงานผล</h4>
          </div>
          <table *ngIf="incomeList.length !== 0" class="table table-borderless">
            <tbody>
              <tr *ngFor="let item of incomeList">
                <th scope="row">{{ item.MEASURE_NAME }}</th>
                <td class="text-right">{{ item.COUNT_REGISTED | number }} คน</td>
                <td class="text-right">{{ item.SUM_PRICE | number }} บาท</td>
              </tr>
            </tbody>
          </table>
        </mat-card>
      </div>
    </div>
  </div>
</div>
